<div *ngIf="!loading">
    <div class="selection-container">
        <div class="selection-item" *ngFor="let selection of selections">
            <button class="btn btn-small btn-clear ">
                {{ selection.title }}
                <span class="icon-ui-close" style="cursor: pointer;" (click)="removeSelection(selection)"></span>
            </button>
        </div>
    </div>
    <div class="region-picker">
        <fieldset class="radio-group">
            <legend class="radio-group-title">Pick a region manually</legend>
            <input class="radio-group-input" type="radio" id="district" value="district" [formControl]="activePicker" (click)="loadData('district')" />
            <label class="radio-group-label" for="district">{{ showPenndotLabel ? 'PennDOT ' : '' }}District</label>
            <input class="radio-group-input" type="radio" id="county" value="county" [formControl]="activePicker" (click)="loadData('county')" />
            <label class="radio-group-label" for="county">County</label>
            <input class="radio-group-input" type="radio" id="municipality" value="municipality"
                   [formControl]="activePicker" (click)="loadData('municipality')" />
            <label class="radio-group-label" for="municipality">Municipality</label>
            <input class="radio-group-input" type="radio" id="planningPartner" value="planningPartner"
                   [formControl]="activePicker" (click)="loadData('planningPartner')" />
            <label class="radio-group-label" for="planningPartner">MPO/RPO</label>
            <input class="radio-group-input" type="radio" id="houseDistrict" value="houseDistrict"
                   [formControl]="activePicker" (click)="loadData('houseDistrict')" />
            <label class="radio-group-label" for="houseDistrict">House</label>
            <input class="radio-group-input" type="radio" id="senateDistrict" value="senateDistrict"
                   [formControl]="activePicker" (click)="loadData('senateDistrict')" />
            <label class="radio-group-label" for="senateDistrict">Senate</label>
            <input class="radio-group-input" type="radio" id="congressionalDistrict" value="congressionalDistrict"
                   [formControl]="activePicker" (click)="loadData('congressionalDistrict')" />
            <label class="radio-group-label" for="congressionalDistrict">Congress</label>
            <input class="radio-group-input" type="radio" id="schoolDistrict" value="schoolDistrict"
                   [formControl]="activePicker" (click)="loadData('schoolDistrict')" />
            <label class="radio-group-label" for="schoolDistrict">School District</label>
            <input class="radio-group-input" type="radio" id="tsmoRegion" value="tsmoRegion"
                   [formControl]="activePicker" />
            <label class="radio-group-label" for="tsmoRegion" *ngIf="showTSMO">TSMO Region</label>
            <input class="radio-group-input" type="radio" id="zipCodes" value="zipCodes"
                   [formControl]="activePicker" (click)="loadData('zipCode')" />
            <label class="radio-group-label" for="zipCodes" *ngIf="showZipCodes">Zip Codes</label>
        </fieldset>
        <div class="district-picker" *ngIf="activePicker.value ==='district'">
            <label>
                District
                <select class="select select-full" name="District" [(ngModel)]="selections" multiple>
                    <option *ngFor="let district of districts" [ngValue]="district">{{ district.title }}
                </select>
            </label>
        </div>
        <div class="county-picker" *ngIf="activePicker.value ==='county'">
            <label>
                County
                <select class="select select-full" name="County" [(ngModel)]="selections" multiple>
                    <option *ngFor="let county of counties" [ngValue]="county">{{ county.title }}</option>
                </select>
            </label>
        </div>
        <form class="municipality-picker" *ngIf="activePicker.value ==='municipality'">
            <label>
                County
                <select class="select select-full" [ngModel]="selectedCounty" name="county"
                        (ngModelChange)="filterMunicipalities($event)">
                    <option *ngFor="let county of counties" [ngValue]="county">{{ county.title }}</option>
                </select>
            </label>
            <label>
                Municipality
                <select class="select select-full" name="municipality" [(ngModel)]="selections" multiple [disabled]="!selectedCounty">
                    <option *ngFor="let municipality of filteredMunicipalties" [ngValue]="municipality">
                        {{ municipality.title }}
                    </option>
                </select>
            </label>
        </form>
        <div class="planning-partner-picker" *ngIf="activePicker.value ==='planningPartner'">
            <label>
                Planning Partner (MPO/RPO)
                <select class="select select-full" name="PlanningPartner" [(ngModel)]="selections" multiple>
                    <option *ngFor="let planningPartner of planningPartners" [ngValue]="planningPartner">
                        {{ planningPartner.title }}
                    </option>
                </select>
            </label>
        </div>
        <div class="house-picker" *ngIf="activePicker.value ==='houseDistrict'">
            <label>
                House
                <select class="select select-full" name="House" [(ngModel)]="selections" multiple>
                    <option *ngFor="let houseDistrict of houseDistricts" [ngValue]="houseDistrict">
                        {{ houseDistrict.title }}
                    </option>
                </select>
            </label>
        </div>
        <div class="senate-picker" *ngIf="activePicker.value ==='senateDistrict'">
            <label>
                Senate
                <select class="select select-full" name="Senate" [(ngModel)]="selections" multiple>
                    <option *ngFor="let senateDistrict of senateDistricts" [ngValue]="senateDistrict">
                        {{ senateDistrict.title }}
                    </option>
                </select>
            </label>
        </div>
        <div class="congressional-picker" *ngIf="activePicker.value ==='congressionalDistrict'">
            <label>
                Congress
                <select class="select select-full" name="Congress" [(ngModel)]="selections" multiple>
                    <option *ngFor="let congressionalDistrict of congressionalDistricts" [ngValue]="congressionalDistrict">
                        {{ congressionalDistrict.title }}
                    </option>
                </select>
            </label>
        </div>
        <form class="municipality-picker" *ngIf="activePicker.value ==='schoolDistrict'">
            <label>
                County
                <select class="select select-full" [ngModel]="selectedSchoolCounty" name="schoolcounty"
                        (ngModelChange)="filterSchoolDistrict($event)">
                    <option *ngFor="let county of counties" [ngValue]="county">{{ county.title }}</option>
                </select>
            </label>
            <label>
                School District
                <select class="select select-full" name="schoolDistrict" [(ngModel)]="selections" multiple [disabled]="!selectedSchoolCounty">
                    <option *ngFor="let schoolDistrict of filteredschoolDistricts" [ngValue]="schoolDistrict">
                        {{ schoolDistrict.schoolDistrictName }}
                    </option>
                </select>
            </label>
        </form>
        <div class="tsmo-picker" *ngIf="activePicker.value === 'tsmoRegion'">
            <label>
                TSMO Region
                <select class="select select-full" name="tsmo" [(ngModel)]="selections" multiple>
                    <option *ngFor="let tsmoRegion of tsmoRegions" [ngValue]="tsmoRegion">
                        {{ tsmoRegion.title }}
                    </option>
                </select>
            </label>
        </div>
        <div class="zip-code-picker" *ngIf="activePicker.value === 'zipCodes'">
            <label>
                Zip Codes
                <input list="zips" type="text" placeholder="Enter Zip Code" [(ngModel)]="selectedZip" />
                <datalist id="zips">
                    <option *ngFor="let zipCode of zipCodes" [ngValue]="zipCode">
                        {{ zipCode.zip }}
                    </option>
                </datalist>
            </label>
        </div>
    </div>
    <section [hidden]="hideRegionSearch" class="region-finder">
        <legend for="searchText">or search for a region</legend>
        <div class="keyword-wrapper">
            <input id="searchText" type="text" [formControl]="searchText" placeholder="Search for a region" autofocus>
        </div>
        <div class="search-results">
            <div class="resultSet" *ngFor="let result of searchResults" (click)="addSelectionFromSearch(result)">
                <span>{{ result.title }}</span>
            </div>
            <div class="resultSet" *ngIf="omitted > 0">
                <span>...{{ omitted }} more search results. Please refine your search.</span>
            </div>
        </div>
    </section>
    <section class="set-defaults" *ngIf="userSettingsComponent && currentUser">
        <button [disabled]="(hasDefaultSelection$ | async) === false" class="btn btn-primary btn-small" (click)="useDefaultSelection()" style="margin-right: .5rem">
            Use Defaults
        </button>
        <label *ngIf="canSaveDefaultSelection" style="display: inline-block;">
            <input type="checkbox" [formControl]="setDefaults">
            Set Selection as Default
        </label>
    </section>
</div>
<div *ngIf="loading">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
